export const SEO_KEYWORDS = {
  home: [
    "digital agency in vancouver",
    "digital agency in canada",
    "digital agency",
    "a digital agency",
    "best digital agency vancouver",
    "best web agency in canada",
    "digital agency vancouver bc",
    "digital web agency vancouver",
    "vancouver digital web agency",
  ],

  solutions: [
    "digital solutions",
  ],

  websiteDevelopment: [
    "website development in canada",
    "website development",
    "website development company",
    "website design and development services",
    "top web development companies",
    "web development company in canada",
    "best website development company",
    "website design and development company",
    "best web development agencies",
    "website development company in canada",
    "website development services company",
    "web development services in canada",
    "web design and development services",
    "best website design and development company",
    "top website development agency",
    "the best web design company",
    "web design and web development services",
    "services in web development",
    "best web design and development company",
    "best web development firm",
    "best web development services company",
    "digital web development agency",
    "the web development company",
    "top web design and development companies",
    "top web development services",
    "web design and web development company",
    "web development and designing company",
    "web development company in canada",
    "web design and development vancouver",
    "web development company in canada",
    "website development services",
    "best web development agency",
    "website development company in canada",
    "best web development company",
    "website design & development company",
  ],

  customToolCreation: [
    "custom web application development",
    "custom web app development",
    "custom web application development company",
    "custom web app development services",
    "bespoke web application",
    "custom web app development service",
    "custom application development",
    "custom web application development",
    "custom web development services",
    "custom web application development company",
    "custom web application development services",
    "custom software application development",
    "custom software application development services",
    "custom web app development services",
    "custom website development services",
    "custom web app development",
    "web application custom development",
    "mobile app development services",
    "mobile application development service",
    "wordpress web design company",
    "android app development services",
    "android app development agency",
    "android application development company",
    "canadian mobile app developers",
    "custom app development company",
    "application development company",
    "mobile app development solutions",
    "mobile app development canada",
    "app development canada",
    "mobile app development in canada",
  ],

  seoServices: [
    "seo services in vancouver",
    "seo services in canada",
    "best seo in vancouver",
    "affordable seo services in canada",
    "seo services",
    "seo",
    "seo agency",
    "seo company",
    "seo company in canada",
    "seo and digital marketing",
    "best seo company canada",
    "seo agency vancouver",
    "best seo services",
    "seo agency canada",
    "search engine optimization service",
    "website seo agency",
    "seo provider",
    "seo optimization agency",
    "seo digital marketing agency",
    "vancouver seo agency",
    "seo agency services",
    "best seo agency in canada",
    "seo company in vancouver",
    "seo engine optimization",
    "local seo company",
    "seo marketing firm",
    "top seo company in canada",
    "seo services provider",
    "seo services vancouver",
    "marketing and seo services",
    "seo service agency",
    "best search engine optimization",
    "best seo experts",
    "seo solutions",
    "seo service company",
    "seo content marketing agency",
    "content optimization",
    "seo agency website",
    "website optimization company",
    "best seo firm",
    "search optimization companies",
    "seo consultant in canada",
    "seo consultant vancouver",
    "seo content optimization",
    "website optimization services",
    "canada seo agency",
    "content marketing seo",
    "seo consultant canada",
    "search engine optimisation service",
    "search engine optimization canada",
    "seo content services",
    "seo vancouver bc",
    "best search engine optimization company",
    "looking for seo services",
    "digital seo agency",
    "content marketing and seo",
    "seo specialist vancouver",
    "best seo service provider",
    "seo optimisation services",
    "best search engine marketing company",
    "seo expert canada",
    "seo optimization canada",
    "digital marketing seo services",
    "seo for agencies",
    "search engine marketing solutions",
    "seo agency in vancouver",
    "local seo vancouver",
    "seo content marketing services",
    "vancouver seo experts",
    "seo and digital marketing services",
    "seo packages canada",
    "search engine optimization vancouver",
    "canada seo services",
    "online seo company",
    "best seo companies in vancouver",
    "seo services company canada",
    "best seo services company",
    "seo expert vancouver",
    "search engine optimisation agency",
    "best search engine optimization services",
    "seo digital company",
    "search engine optimization specialists",
    "vancouver seo consultant",
    "search engine optimization in vancouver",
    "seo canada services",
    "web seo services",
    "digital seo company",
    "search engine optimisation seo services",
    "content optimisation",
    "online search engine optimization",
    "search engine optimization vancouver bc",
    "best search engine marketing",
    "best search engine optimization agency",
    "best seo company services",
    "best seo company vancouver",
    "best seo in vancouver",
    "best seo services canada",
    "best seo services company in canada",
    "best seo services in canada",
    "best seo vancouver",
    "canada search engine optimization",
    "canada seo expert",
    "expert vancouver seo",
    "local business seo company",
    "local search engine marketing company",
    "local search engine optimization company",
    "local seo company vancouver",
    "local seo services vancouver",
    "online seo agency",
    "search engine marketing company vancouver",
    "search engine marketing specialists",
    "search engine marketing vancouver",
    "search engine optimisation specialists",
    "search engine optimization and search engine marketing",
    "search engine optimization experts",
    "search engine optimization service provider",
    "search engine optimization services canada",
    "search engine optimization services company",
    "search engine optimization services vancouver",
    "search engine ranking optimization",
    "search optimisation agency",
    "search optimization services",
    "seo company vancouver bc",
    "seo expert in canada",
    "seo in vancouver bc",
    "seo service provider company",
    "seo services vancouver bc",
    "seo vancouver agency",
    "seo vancouver company",
    "seo vancouver expert",
    "technical seo agency vancouver",
    "technical seo services vancouver",
    "top seo expert vancouver",
    "top seo services in canada",
    "top seo vancouver",
    "vancouver bc seo",
    "vancouver bc seo agency",
    "vancouver local seo",
    "vancouver local seo expert",
    "vancouver search engine marketing",
    "vancouver search engine optimization",
    "vancouver seo specialist",
    "web search engine optimization",
    "website seo in vancouver",
    "local seo services vancouver",
    "seo agency vancouver",
    "local seo companies vancouver",
    "seo companies in vancouver",
    "vancouver local seo expert",
    "seo in vancouver bc",
    "seo agency in vancouver",
    "seo services in vancouver",
    "local seo services",
    "local seo vancouver",
    "seo company in vancouver",
    "best seo company in canada",
    "consultant seo services",
    "local seo canada",
    "local seo specialist",
    "seo for small businesses",
    "affordable seo",
    "best seo providers",
    "agency for local seo",
    "best seo blogs",
    "content marketing seo services",
    "international seo services",
    "local seo company vancouver",
    "seo solutions",
    "vancouver local seo",
    "wordpress seo services",
    "affordable search engine optimization",
    "affordable seo company",
    "best seo services company",
    "local seo experts",
    "seo link building services",
    "seo professional services",
    "best seo services in canada",
    "global seo company",
    "local seo services canada",
    "top seo company in canada",
    "vancouver local seo expert",
    "wordpress seo consultant",
    "best local seo services",
    "global seo agency",
    "google my business seo service",
    "local seo for businesses",
    "top seo firm in canada",
    "affordable seo canada",
    "the best seo company",
  ],

  socialMediaMarketing: [
    "social media management services",
    "social media marketing vancouver",
    "content marketing canada",
    "social media monitoring tools",
    "website management",
    "best social media marketing agency",
    "social media marketing service",
    "advertising platforms",
    "social media management agency",
    "branding through social media",
    "advertising via social media",
    "social media marketing services in canada",
    "marketing strategy using social media",
    "social media marketing agency canada",
  ],

  maintenanceSupport: [
    "website maintenance services",
    "website maintenance company",
    "maintenance site wordpress",
    "website maintenance and support services",
    "website maintenance support",
    "website support and maintenance services",
    "website maintenance vancouver",
    "wordpress webmaster services",
    "wordpress website support services",
    "website maintenance companies",
  ],

  about: [],

  contact: [],

  faqs: [],

  blog: [],
};